// Local selectors for open additional account :
import { createStructuredSelector } from "reselect";
import {
  fetchStepCountNum,
  fetchStepperConfig,
  fetchStepperIndex,
  fetchStepperEdit,
} from "../../../selectors/globalSelectors";

// fetching npaFormReducer :
export const fetchLocalReducer = (store) => store.npaFormReducer;

// fetching newly created account number
export const fetchAccountName = (state) => {
  const { accNum } = fetchLocalReducer(state);
  return accNum;
};

// fetching primary user info
export const fetchPrimaryUserInfo = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.info;
};

// fetching fund name
export const fetchFundName = (state) => {
  const { tempJSON } = fetchLocalReducer(state);
  return tempJSON.tempJSON.tempJSON.fundName;
};

// fetching step count name
export const fetchStepCount = (state) => {
  const { activePageStepName } = fetchLocalReducer(state);
  return activePageStepName;
};

// fetching step one edit
export const fetchStep1Edit = (state) => {
  const { isStep1Edit } = fetchLocalReducer(state);
  return isStep1Edit.isStep1Edit;
};

// fetching temp data
export const fetchTempData = (state) => {
  const { tempJSON } = fetchLocalReducer(state);
  return tempJSON.tempJSON;
};

// fetching temp data
export const fetchLoader = (state) => {
  const { apiLoader } = fetchLocalReducer(state);
  return apiLoader;
};

// fetching primary advisor emails
export const fetchPrimaryAdvEmail = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.email.email;
};

// fetching primary advisor phones
export const fetchPrimaryAdvPhone = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.phone.phone;
};

// fetching primary advisor address
export const fetchPrimaryAdvAddresses = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.addresses.addresses;
};

// fetching primary advisor related donor
export const fetchPrimaryAdvRelatedDonor = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.relatedDonor.relatedDonor;
};

// fetching secondary advisor phone
export const fetchSecondaryAdvPhone = (state) => {
  const { secondaryAdvisor } = fetchLocalReducer(state);
  return secondaryAdvisor.phone.phone;
};

// fetching secondary advisor Email
export const fetchSecondaryAdvEmail = (state) => {
  const { secondaryAdvisor } = fetchLocalReducer(state);
  return secondaryAdvisor.email.email;
};

// fetching secondary advisor Addresses
export const fetchSecondaryAdvAddresses = (state) => {
  const { secondaryAdvisor } = fetchLocalReducer(state);
  return secondaryAdvisor.addresses.addresses;
};

// fetching secondary advisor relatedDonor
export const fetchSecondaryAdvRelatedDonor = (state) => {
  const { secondaryAdvisor } = fetchLocalReducer(state);
  return secondaryAdvisor.relatedDonor;
};

// fetching primary advisor disable
export const fetchDisable = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.disable;
};

// fetching primary advisor dropdown
export const fetchDropDown = (state) => {
  const { dropdownValues } = fetchLocalReducer(state);
  return dropdownValues.data;
};

// fetching primary advisor info
export const fetchPrimaryAdvInfo = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.info;
};

// fetching temp info
export const fetchTempInfo = (state) => {
  const { tempInfo } = fetchLocalReducer(state);
  return tempInfo;
};

// fetching status
export const fetchStatus = (state) => {
  const { status } = fetchLocalReducer(state);
  return status;
};

// fetching secondary advisor info
export const fetchSecondaryAdvInfo = (state) => {
  const { secondaryAdvisor } = fetchLocalReducer(state);
  return secondaryAdvisor.info;
};

// fetching temp data one
export const fetchOneTempData = (state) => {
  const { tempJSON } = fetchLocalReducer(state);
  return tempJSON.tempJSON;
};

// fetching temp data one
export const fetchAlertsOoa = (state) => {
  const { alerts } = fetchLocalReducer(state);
  return alerts;
};

// fetching legacy Options
export const fetchLegacyOptions = (state) => {
  const { legacyOptions } = fetchLocalReducer(state);
  return legacyOptions.legacyOptions;
};

// fetching Account name error
export const fetchAccountNameErr = (state) => {
  const { error } = fetchLocalReducer(state);
  return error.accountNameError;
};

// fetching fund name
export const fetchAccountFundName = (state) => {
  const { fundName } = fetchLocalReducer(state);
  return fundName.fundName.fundName;
};

// fetching step 2 edit flag
export const fetchStepTwoEdit = (state) => {
  const { isStep2Edit } = fetchLocalReducer(state).isStep2Edit;
  return isStep2Edit ? isStep2Edit.isStep2Edit : isStep2Edit;
};

// fetching shouldEmptyZip
export const fetchEmptyZip = (state) => {
  const { shouldEmptyZip } = fetchLocalReducer(state).shouldEmptyZip;
  return shouldEmptyZip ? shouldEmptyZip.shouldEmptyZip : shouldEmptyZip;
};

// fetching country dropdown
export const fetchCountryDropdown = (state) => {
  const { dropdownValues } = fetchLocalReducer(state);
  return dropdownValues.data.countries;
};

// fetching state dropdown
export const fetchStateDropdown = (state) => {
  const { dropdownValues } = fetchLocalReducer(state);
  return dropdownValues.data.states;
};

// fetching relationship dropdown
export const fetchRelationshipDropdown = (state) => {
  const { relationshipValuesNew } = fetchLocalReducer(state);
  return relationshipValuesNew;
};

// fetching title dropdown
export const fetchTitleDropdown = (state) => {
  const { dropdownValues } = fetchLocalReducer(state);
  return dropdownValues.data.title;
};

// fetching suffix dropdown
export const fetchSuffixDropdown = (state) => {
  const { dropdownValues } = fetchLocalReducer(state);
  return dropdownValues.data.suffix;
};

// fetching gender dropdown
export const fetchGenderDropdown = (state) => {
  const { dropdownValues } = fetchLocalReducer(state);
  return dropdownValues.data.gender;
};

// fetching accordion states
export const fetchAccordionStates = (state) => {
  const { accordionStates } = fetchLocalReducer(state);
  return accordionStates;
};

// fetching show more state
export const fetchShowMoreStates = (state) => {
  const { showMore } = fetchLocalReducer(state).showMore;
  return showMore ? showMore.showMore : showMore;
};

// fetching if is secondary
export const fetchingIsSecondary = (state) => {
  const { isSecondaryAdvisor } = fetchLocalReducer(state);
  return isSecondaryAdvisor.isSecondaryAdvisor;
};

// fetching related contributor info
export const fetchingRelContributor = (state) => {
  const { primaryAdvisor } = fetchLocalReducer(state);
  return primaryAdvisor.relatedDonor;
};

// fetching temp CheckBox Status
export const fetchingTempCheckBoxStatus = (state) => {
  const { tempCheckBoxStatus } = fetchLocalReducer(state);
  return tempCheckBoxStatus;
};

// fetching should close
export const fetchingShouldClose = (state) => {
  const { shouldClose } = fetchLocalReducer(state).shouldClose;
  return shouldClose ? shouldClose.shouldClose : shouldClose;
};

// fetching accordion Open Status
export const fetchingAccordionOpenStatus = (state) => {
  const { accordionOpenStatus } = fetchLocalReducer(state);
  return accordionOpenStatus;
};

// LegacyAccordions: component step two
export const LegacyAccordionsTwoStates = createStructuredSelector({
  hasFieldValues: fetchingShouldClose,
  accordionOpenStatus: fetchingAccordionOpenStatus,
  isStep2Edit: fetchStepTwoEdit,
  stepperUpdateIndex: fetchStepperIndex,
  accordionState: fetchAccordionStates,
  alertOOA: fetchAlertsOoa,
});

// MainPage: component
export const MainPageDerivedStates = createStructuredSelector({
  stepperConfig: fetchStepperConfig,
  activePageStepNumber: fetchStepCountNum,
  isSecondary: fetchingIsSecondary,
  tempCheckBoxStatus: fetchingTempCheckBoxStatus,
});

// Details: component
export const DetailsDerivedStates = createStructuredSelector({
  countryDropdown: fetchCountryDropdown,
  titleDropdown: fetchTitleDropdown,
  genderDropdown: fetchGenderDropdown,
  suffixDropdown: fetchSuffixDropdown,
  relationshipDropdown: fetchRelationshipDropdown,
  isSecondary: fetchingIsSecondary,
  relatedContributorInfo: fetchingRelContributor,
});

// LegacyAccordion: component step 3
export const LegacyAccordionDerivedStates = createStructuredSelector({
  showMore: fetchShowMoreStates,
  tempData: fetchOneTempData,
});

// AccordionContent: component
export const AccordionContentDerivedStates = createStructuredSelector({
  isStep2Edit: fetchStepTwoEdit,
  tempData: fetchOneTempData,
  accordionStates: fetchAccordionStates,
});

// SuccessorInfo: component
export const SuccessorInfoStates = createStructuredSelector({
  relationshipDropDown: fetchRelationshipDropdown,
  titleDropDown: fetchTitleDropdown,
  suffixDropDown: fetchSuffixDropdown,
  genderDropDown: fetchGenderDropdown,
});

// CharityBasicInfo, EmailInfo: component
export const CommonInfoDerivedStates = createStructuredSelector({
  isStep2Edit: fetchStepTwoEdit,
  tempData: fetchOneTempData,
  stepperUpdateIndex: fetchStepperIndex,
});

// AddressInfo: component
export const AddressInfoDerivedStates = createStructuredSelector({
  countryDropDown: fetchCountryDropdown,
  stateDropDown: fetchStateDropdown,
  shouldEmptyZip: fetchEmptyZip,
  isStep2Edit: fetchStepTwoEdit,
  tempData: fetchOneTempData,
  stepperUpdateIndex: fetchStepperIndex,
});

// AccountName: component
export const AccountNameDerivedStates = createStructuredSelector({
  fundName: fetchAccountFundName,
  accountNameError: fetchAccountNameErr,
  tempData: fetchOneTempData,
  isStep2Edit: fetchStepTwoEdit,
  stepperUpdateIndex: fetchStepperIndex,
});

// Step2Main: component
export const StepTwoMainStates = createStructuredSelector({
  stepperConfig: fetchStepperConfig,
  activePageStepNumber: fetchStepCountNum,
  legacy: fetchLegacyOptions,
});

// AccountCreated: component
export const AccountCreatedDerivedStates = createStructuredSelector({
  accNum: fetchAccountName,
  primaryUserInfo: fetchPrimaryUserInfo,
  fundName: fetchFundName,
});
